import React from 'react';
export function Footer() {
  return <footer className="bg-deep-blue border-t border-white/10 py-12" data-id="element-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center" data-id="element-21">
        <p className="text-blue-200/60 text-sm font-light" data-id="element-22">
          Todos los derechos reservados &copy; {new Date().getFullYear()}
        </p>
      </div>
    </footer>;
}